<template>
  <div class="officials-filter">
    <div
      v-if="!showFilterMobile"
      class="officials-filter__mobile-toggle d-md-none row">
      <button
        class="col-10 offset-4 btn btn--secondary"
        @click="toggleShowFilterMobile()" >{{ $t('cac.app.filter_candidates') }}</button>
    </div>
    <div
      :class="{'d-block': showFilterMobile}"
      class="officials-filter__content d-none d-md-block">
      <officials-page-toggle class="d-none d-md-flex"/>
      <hr class="mt-4 mb-3 d-none d-md-block">
      <form
        class="officials-filter__form"
        @submit.prevent="onFilter"
      >
        <legend class="officials-filter__title officials-filter__title--mobile d-md-none">{{ $t('cac.app.filter_candidates') }}</legend>
        <legend class="officials-filter__title officials-filter__title--desktop d-none d-md-block">{{ $t('cac.app.narrow_down_results') }}</legend>
        <div class="cac-input-wrapper__list-group">
          <cac-input-wrapper
            v-if="hasTypeFilter"
            :title="$t('cac.app.type_of_candidate')"
            class="officials-filter__form--title cac-input-wrapper__list-group--item cac-input-wrapper__list-group--first cac-input-wrapper__list-group--white"
            for="officials-filter__select-type">
            <cac-select
              id="officials-filter__select-type"
              v-model="filterStates.candidateType"
              :options="candidateTypes"
              :show-placeholder="false"
            />
          </cac-input-wrapper>
          <cac-input-wrapper
            :class="{'cac-input-wrapper__list-group--first': !hasTypeFilter}"
            :title="$t('cac.app.party')"
            class="officials-filter__form--title cac-input-wrapper__list-group--item cac-input-wrapper__list-group--last cac-input-wrapper__list-group--white"
            for="officials-filter__select-party">
            <cac-select
              id="officials-filter__select-party"
              v-model="filterStates.party"
              :options="parties"
              :show-placeholder="false"
            />
          </cac-input-wrapper>
        </div>
        <div class="row mt-3 mt-md-4">
          <button
            type="submit"
            class="btn btn--primary officials-filter__submit col-8 offset-5 col-md-10 offset-md-0">
            {{ $t('cac.app.filter') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CANDIDATE_TYPES from "Constants/campaign/civicactioncenter/candidateTypes";
import PARTIES from "Constants/campaign/civicactioncenter/parties";
import CacInputWrapper from "CivicActionCenterComponents/utilities/CACInputWrapper.vue";
import CacSelect from "CivicActionCenterComponents/utilities/CACSelect.vue";
import OfficialsPageToggle from "CivicActionCenterComponents/shared/OfficialsPageToggle.vue";

export default {
  name: "OfficialsFilter",
  components: {
    CacInputWrapper,
    CacSelect,
    OfficialsPageToggle
  },
  model: {
    prop: "filters",
    event: "filter"
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterStates: { ...this.filters },
      showFilterMobile: false
    };
  },
  computed: {
    hasTypeFilter() {
      return Object.hasOwnProperty.call(this.filters, "candidateType");
    },
    candidateTypes() {
      return [
        {
          value: CANDIDATE_TYPES.ANY_TYPE,
          label: this.$t("cac.app.any_candidate")
        },
        {
          value: CANDIDATE_TYPES.INCUMBENT,
          label: this.$t("cac.app.incumbent")
        },
        {
          value: CANDIDATE_TYPES.CHALLENGER,
          label: this.$t("cac.app.challenger")
        }
      ];
    },
    parties() {
      return [
        {
          value: PARTIES.ANY_PARTY,
          label: this.$t("cac.app.any_party")
        },
        {
          value: PARTIES.DEMOCRAT,
          label: this.$t("cac.app.democrat")
        },
        {
          value: PARTIES.REPUBLICAN,
          label: this.$t("cac.app.republican")
        },
        {
          value: PARTIES.INDEPENDENT,
          label: this.$t("cac.app.independent")
        },
        {
          value: PARTIES.OTHER,
          label: this.$t("cac.app.other")
        }
      ];
    }
  },
  watch: {
    filters() {
      this.filterStates = { ...this.filters };
    }
  },
  methods: {
    toggleShowFilterMobile() {
      this.showFilterMobile = !this.showFilterMobile;
    },
    onFilter() {
      this.$emit("filter", this.filterStates);
    }
  }
};
</script>
